import { useEffect, useState } from "react";
import axiosInstance from "../utils/axiosInstance";

export const useProductData = (slug) => {
  const [product, setProduct] = useState(null);
  const [activeSub, setActiveSub] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) return;

    const trimmedSlug = slug.trim();

    const fetchProduct = async () => {
      setLoading(true);
      setError(null);

      try {
        // ✅ Reusable populate query (FIXED)
        const populateQuery = [
          "populate[sub_products][populate][sub_product_image][fields]=url",
          "populate[sub_products][populate][product_details][populate][images][fields]=url,alternativeText",
          "populate[sub_products][populate][tour_details][populate]=*",
          "populate[sub_products][populate][faq][populate]=*",
        ].join("&");

        // ✅ First API call
        const res = await axiosInstance.get(`/products?${populateQuery}`);
        const allProducts = res.data?.data || [];

        

        // ✅ Find main product
        let productData = allProducts.find(
          (prod) => prod.slug === trimmedSlug
        );

        let subData = null;

        // ✅ If slug belongs to sub-product
        if (!productData) {
          for (let prod of allProducts) {
            const sub = prod.sub_products?.find(
              (s) => s.slug === trimmedSlug
            );

            if (sub) {
              subData = sub;

              // 🔥 IMPORTANT FIX: use SAME populate query
              const singleRes = await axiosInstance.get(
                `/products/${prod.documentId}?${populateQuery}`
              );

              productData = singleRes.data?.data;
              break;
            }
          }
        }

        // ❌ Not found
        if (!productData) {
          setError("Product not found");
          setProduct(null);
          setActiveSub(null);
          return;
        }

        // ✅ Filter visible sub-products
        const visibleSubProducts = (productData.sub_products || []).filter(
          (sub) => sub.is_hidden !== true
        );

        

        // ✅ Normalize data (FIXED image handling)
        const subProducts = visibleSubProducts.map((sub) => ({
          ...sub,

          // ✅ Sub product image fix (handles Strapi structure)
          sub_product_image:
            sub?.sub_product_image?.url ||
            sub?.sub_product_image?.attributes?.url ||
            "https://via.placeholder.com/400x250?text=No+Image",

          // ✅ Product details images fix
          product_details: (sub.product_details || []).map((pd) => ({
            ...pd,
            images: (pd.images || []).map((img) => ({
              url:
                img?.url ||
                img?.attributes?.url ||
                "https://via.placeholder.com/400x250?text=No+Image",
              alternativeText:
                img?.alternativeText ||
                img?.attributes?.alternativeText ||
                "",
            })),
          })),

          rating: sub.rating,
          views: sub.views,
        }));

        

        // ✅ Final state
        setProduct({
          ...productData,
          sub_products: subProducts,
        });

        setActiveSub(subData || null);
      } catch (err) {
        console.error(err);
        setError(err.message || "Something went wrong");
        setProduct(null);
        setActiveSub(null);
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [slug]);

  return { product, activeSub, loading, error };
};